import { ChartDivId } from "Components/Chart/chartInterface";
import html2canvas from "html2canvas";
import { isDefined } from "Utils/functions";

export interface AdviceChartURIs {
  deathNeedChartURI?: string;
  deathSelectedChartURI?: string;
  disabilityMonthlyChartURI?: string;
  disabilityYearlyChartURI?: string;
  criticalIllnessChartURI?: string;
}

export const getAdviceCharts = async (
  ref: HTMLDivElement | null,
): Promise<AdviceChartURIs | undefined> => {
  try {
    const deathNeedChartURI = await extractChart(ChartDivId.DEATH_NEED, ref);
    const deathSelectedChartURI = await extractChart(
      ChartDivId.DEATH_SELECTED,
      ref,
    );
    const disabilityMonthlyChartURI = await extractChart(
      ChartDivId.DISABILITY_MONTHLY,
      ref,
    );
    const disabilityYearlyChartURI = await extractChart(
      ChartDivId.DISABILITY_YEARLY,
      ref,
    );
    const criticalIllnessChartURI = await extractChart(
      ChartDivId.CRITICAL_ILLNESS,
      ref,
    );

    return {
      deathSelectedChartURI,
      deathNeedChartURI,
      disabilityMonthlyChartURI,
      disabilityYearlyChartURI,
      criticalIllnessChartURI,
    };
  } catch {
    return undefined;
  }
};

const extractChart = async (
  divId: ChartDivId,
  ref: HTMLDivElement | null,
): Promise<string | undefined> => {
  if (isDefined(ref)) {
    const chart = ref.querySelector(`#${divId}`);
    if (isDefined(chart)) {
      return await html2canvas(chart as HTMLElement, { scale: 2 }).then(
        (canvas) => canvas.toDataURL(),
      );
    }
  }
};
